import IBAN from 'iban';
import { Alphabet, PureISO7064 } from '@konfirm/iso7064';
import eweOldCodes from '../assets/ewe_old_codes';
import osnatelOldCodes from '../assets/osnatel_old_codes';

const kwkCodeCheck = (code: string) => {
  const validator = new PureISO7064({
    radix: 2,
    modulus: 11,
    indices: Alphabet.from('0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'),
    alphabet: Alphabet.from('0123456789X'),
  });
  const codeLength = code.length;
  const checksum = code.slice(codeLength - 7, codeLength - 6);
  const slicedCode = code.slice(codeLength - 6, codeLength);

  return checksum === validator.checksum(slicedCode).replace('0', 'A');
};
const mandatory = [(value: string | number) => !!value || 'Dieses Feld wird benötigt!'];
const mandatoryBoolean = [
  (value: boolean) => value === true || value === false || 'Dieses Feld wird benötigt!',
];

function buildRulesRequiredDefined<T>() {
  return [(value: T) => value !== undefined || 'Dieses Feld wird benötigt!'];
}

const iban = [
  (value: string) => !!value || 'Dieses Feld wird benötigt!',
  (value: string) => /^DE\d{2}\s?([0-9a-zA-Z]{4}\s?){4}[0-9a-zA-Z]{2}$/.test(value)
    || 'Format: DE00 0000 0000 0000 0000 00',

  (value: string) => IBAN.isValid(value) || 'IBAN nicht gültig',
];

function buildRulesEMail(required = false) {
  const rules: Array<(value: string) => boolean | string> = [
    (value: string) => !value || /^((?!.*[ÄÖÜäöü].*).)*$/.test(value) || 'Es sind keine Umlaute zulässig.',
    (value: string) => !value
      || /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        value,
      ) || 'Bitte geben Sie eine valide E-Mail ein.',
  ];
  if (required) {
    rules.unshift((value: string) => !!value || 'Dieses Feld wird benötigt!');
  }
  return rules;
}

const referralCode = [
  (value: string) => eweOldCodes.includes(value)
    || osnatelOldCodes.includes(value)
    || (kwkCodeCheck(value) && (value.includes('EWE') || value.includes('OSNATEL')))
    || 'Ungültiger Code',
];

const externalOrderNumberRule = [
  (externalOrderNumber: string) => /^[a-zA-Z0-9]{5,12}$/gi.test(externalOrderNumber)
    || 'Minimal 5 Zeichen. Keine Sonderzeichen erlaubt',
];

const checkEeccId = [
  (eeccId: string) => !!eeccId || 'Dieses Feld wird benötigt!',
  (eeccId: string) => /^[a-z0-9]{9}$/.test(eeccId) || 'Ungültiges Format',
];

export {
  mandatory,
  mandatoryBoolean,
  buildRulesEMail,
  buildRulesRequiredDefined,
  iban,
  referralCode,
  externalOrderNumberRule,
  checkEeccId,
};
